import { render, staticRenderFns } from "./TableFieldtype.vue?vue&type=template&id=41889def&"
import script from "./TableFieldtype.vue?vue&type=script&lang=js&"
export * from "./TableFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports